<template>
    <div class="duels-games">
        <div class="games-my">
            <div class="my-header">
                <div class="header-title">
                    <span style="color: var(--text-primary);">MY GAMES</span>
                    ({{duelsGetGames.user.length}})
                </div>
                <button class="mobile-toggle" @click="toggleMyGames" v-if="isMobile">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
            </div>
            <div class="my-content" v-bind:class="{ 'content-collapsed': isMobile && !myGamesExpanded }">
                <transition name="fade" mode="out-in">
                    <div v-if="socketDuels.connected === false" class="content-loading" key="loading">

                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>

                    </div>
                    <div v-else-if="duelsGetGames.user.length > 0" class="content-list" key="data">

                        <DuelsGamesElement v-for="game of duelsGetGames.user" v-bind:key="game._id" v-bind:game="game" />

                    </div>
                    <div v-else class="content-empty" key="empty">You dont have any active duels. Start by creating one!</div>
                </transition>
            </div>
        </div>
        <div class="games-all">
            <div class="all-header">
                <div class="header-title">
                    <span>ALL GAMES</span>
                    ({{duelsGetGames.all.length}})
                </div>
                <div class="header-actions">
                    <DuelsFilterSort />
                    <button class="mobile-toggle" @click="toggleAllGames" v-if="isMobile">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </button>
                </div>
            </div>
            <div class="all-content" v-bind:class="{ 'content-collapsed': isMobile && !allGamesExpanded }">
                <transition name="fade" mode="out-in">
                    <div v-if="socketDuels.connected === false" class="content-loading" key="loading">

                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>
                        <div class="loading-placeholder"></div>

                    </div>
                    <div v-else-if="duelsGetGames.all.length > 0" class="content-list" key="data">

                        <DuelsGamesElement v-for="game of duelsGetGames.all" v-bind:key="game._id" v-bind:game="game" />

                    </div>
                    <div v-else class="content-empty" key="empty">There are no duels. Be the first by creating one!</div>
                </transition>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import DuelsFilterSort from '@/components/duels/DuelsFilterSort';
    import DuelsGamesElement from '@/components/duels/DuelsGamesElement';

    export default {
        name: 'DuelsGames',
        components: {
            DuelsFilterSort,
            DuelsGamesElement
        },
        data() {
            return {
                myGamesExpanded: true,
                allGamesExpanded: true,
                isMobile: false
            }
        },
        methods: {
            toggleMyGames() {
                this.myGamesExpanded = !this.myGamesExpanded;
            },
            toggleAllGames() {
                this.allGamesExpanded = !this.allGamesExpanded;
            },
            checkMobile() {
                this.isMobile = window.innerWidth <= 768;
            }
        },
        mounted() {
            this.checkMobile();
            window.addEventListener('resize', this.checkMobile);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile);
        },
        computed: {
            ...mapGetters([
                'socketDuels', 
                'authUser', 
                'duelsFilterSort', 
                'duelsGames', 
                'duelsHistory'
            ]),
            duelsGetGames() {
                let games = { user: [], all: [] };

                for(const game of this.duelsGames) {
                    if(this.authUser.user !== null && game.bets.some((element) => element.user._id === this.authUser.user._id) === true) {
                        games.user.push(game);
                    } else {
                        games.all.push(game);
                    }
                }

                if(this.duelsFilterSort === 'HIGHEST PRICE') { games.all.sort(function(a, b) { return b.amount - a.amount; }); }
                else if(this.duelsFilterSort === 'LOWEST PRICE') { games.all.sort(function(a, b) { return a.amount - b.amount; }); }
                else if(this.duelsFilterSort === 'PARTICIPANTS') { games.all.sort(function(a, b) { return b.bets.length - a.bets.length; }); }
                else { games.all.sort(function(a, b) { return new Date(b.createdAt) - new Date(a.createdAt); }); }

                games.all = [...games.all, ...this.duelsHistory];

                return games;
            }
        }
    }
</script>

<style scoped>
    .duels-games {
        width: 1160px;
        margin-top: 30px;
        margin-left: 10px;
    }

    .duels-games .games-my,
    .duels-games .games-all {
        width: 100%;
        padding: 20px;
        border-radius: 16px;
        background: linear-gradient(135deg, rgba(26, 41, 66, 0.25) 0%, rgba(15, 25, 35, 0.35) 100%);
        border: 1px solid rgba(184, 115, 51, 0.2);
        box-shadow: 
            0 4px 24px rgba(0, 0, 0, 0.3),
            inset 0 1px 0 rgba(255, 255, 255, 0.03);
        backdrop-filter: blur(8px);
    }

    .duels-games .games-all {
        margin-top: 26px;
        padding-bottom: 24px;
    }

    .duels-games .my-header,
    .duels-games .all-header {
        width: 100%;
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: 'Satoshi', sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: rgba(184, 115, 51, 0.7);
        padding-bottom: 16px;
        margin-bottom: 20px;
        border-bottom: 2px solid rgba(184, 115, 51, 0.2);
    }

    .duels-games .mobile-toggle {
        display: none;
        background: rgba(26, 26, 26, 0.6);
        border: 1px solid rgba(184, 115, 51, 0.3);
        border-radius: 8px;
        color: rgba(184, 115, 51, 0.9);
        cursor: pointer;
        padding: 8px 12px;
        transition: all 0.3s ease;
    }

    .duels-games .mobile-toggle:hover {
        background: rgba(26, 26, 26, 0.8);
        border-color: rgba(184, 115, 51, 0.5);
        box-shadow: 0 0 12px rgba(184, 115, 51, 0.2);
    }

    .duels-games .mobile-toggle svg {
        transition: transform 0.3s ease;
    }

    .duels-games .content-collapsed {
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
        padding: 0 !important;
        margin: 0 !important;
    }

    .duels-games .my-content,
    .duels-games .all-content {
        transition: max-height 0.3s ease;
        overflow: hidden;
    }

    .duels-games .header-title {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: 'Satoshi', sans-serif;
        font-size: 13px;
        font-weight: 600;
        color: rgba(184, 115, 51, 0.7);
    }

    .duels-games .header-title span {
        font-family: 'Clash Display', sans-serif;
        font-size: 18px;
        font-weight: 700;
        background: var(--gradient-yellow);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        letter-spacing: 0.5px;
    }

    .duels-games .header-actions {
        display: flex;
        align-items: center;
    }

    .duels-games .header-actions button.button-history {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 700;
        color: #5e768e;
        transition: color 0.3s ease;
    }

    .duels-games .header-actions button.button-history:hover {
        color: #ffffff;
    }

    .duels-games .header-actions button.button-history svg {
        margin-right: 8px;
        fill: #5e768e;
        transition: fill 0.3s ease;
    }

    .duels-games .header-actions button.button-history:hover svg {
        fill: #ffffff;
    }

    .duels-games .my-content {
        width: 100%;
        min-height: 75px;
        display: flex;
        flex-wrap: wrap;
        margin-top: 0;
    }

    .duels-games .all-content {
        max-height: 409px;
        margin-top: 0;
        margin-right: -20px;
        padding-right: 16px;
        overflow-y: scroll;
    }

    .duels-games .all-content::-webkit-scrollbar {
        width: 6px;
        height: 0;
    }

    .duels-games .all-content::-webkit-scrollbar-track {
        background: rgba(26, 26, 26, 0.5);
        border-radius: 3px;
    }

    .duels-games .all-content::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, rgba(184, 115, 51, 0.6) 0%, rgba(184, 115, 51, 0.4) 100%);
        border-radius: 3px;
        transition: background 0.3s ease;
    }

    .duels-games .all-content::-webkit-scrollbar-thumb:hover {
        background: linear-gradient(180deg, rgba(184, 115, 51, 0.8) 0%, rgba(184, 115, 51, 0.6) 100%);
    }

    .duels-games .content-loading {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .duels-games .content-loading.fade-leave-active {
        transition: opacity 0.5s;
    }

    .duels-games .content-loading.fade-leave-to {
        opacity: 0;
    }

    .duels-games .loading-placeholder {
        width: calc(33.33% - 13.33px);
        height: 123px;
        position: relative;
        margin-top: 0;
        margin-right: 20px;
        border-radius: 15px;
        overflow: hidden;
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.6) 0%, rgba(13, 13, 13, 0.8) 100%);
        border: 1px solid rgba(184, 115, 51, 0.1);
    }

    .duels-games .loading-placeholder::after {
        width: 100%;
        height: 100%;
        position: absolute;
        content: '';
        top: 0;
        left: 0;
        animation-name: loading_animation;
        animation-duration: 1.5s;
        animation-timing-function: ease-in-out;
        animation-iteration-count: infinite;
        background: linear-gradient(90deg, transparent 0%, rgba(184, 115, 51, 0.15) 50%, transparent 100%);
    }

    .duels-games .loading-placeholder:nth-child(3n) {
        margin-right: 0;
    }

    .duels-games .content-list {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }

    .duels-games .content-empty {
        width: 100%;
        height: 85px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 12px;
        text-transform: uppercase;
        font-family: 'Satoshi', sans-serif;
        font-size: 13px;
        font-weight: 700;
        letter-spacing: 0.5px;
        color: rgba(184, 115, 51, 0.8);
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.5) 0%, rgba(13, 13, 13, 0.7) 100%);
        border: 1px solid rgba(184, 115, 51, 0.2);
        box-shadow: inset 0 0 20px rgba(184, 115, 51, 0.05);
    }

    .duels-games .content-list.fade-enter-active,
    .duels-games .content-empty.fade-enter-active {
        transition: opacity 0.5s;
    }

    .duels-games .content-list.fade-enter-from,
    .duels-games .content-empty.fade-enter-from {
        opacity: 0;
    }

    @keyframes loading_animation {
        0% { transform: translateX(-100%); }
        50% { transform: translateX(100%); }
        100% { transform: translateX(100%); }
    }

    @media only screen and (max-width: 1250px) {
        .duels-games .all-content {
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 1180px) {
        .duels-games {
            width: 100%;
            margin-left: 0;
        }
    }

    @media only screen and (max-width: 1050px) {
        .duels-games .loading-placeholder {
            width: calc(50% - 10px);
        }

        .duels-games .loading-placeholder:nth-child(3n) {
            margin-top: 20px;
            margin-right: 20px;
        }

        .duels-games .loading-placeholder:nth-child(2n) {
            margin-right: 0;
        }
    }

    @media only screen and (max-width: 950px) {
        .duels-games .games-my,
        .duels-games .games-all {
            padding: 16px;
            border-radius: 14px;
        }

        .duels-games .my-header,
        .duels-games .all-header {
            padding-bottom: 12px;
            margin-bottom: 16px;
        }
    }

    @media only screen and (max-width: 768px) {
        .duels-games {
            margin-top: 15px;
        }

        .duels-games .games-my {
            padding: 14px;
            border-radius: 12px;
        }

        .duels-games .games-all {
            display: none;
        }

        .duels-games .my-header {
            padding-bottom: 12px;
            margin-bottom: 14px;
            font-size: 12px;
        }

        .duels-games .header-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
        }

        .duels-games .header-title span {
            font-size: 16px;
        }

        .duels-games .header-actions {
            display: flex;
            align-items: center;
        }

        .duels-games .mobile-toggle {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 6px 10px;
        }

        .duels-games .my-content {
            max-height: 2000px;
        }

        .duels-games .content-collapsed {
            max-height: 0;
            padding: 0;
            margin: 0;
            overflow: hidden;
        }

        .duels-games .content-empty {
            height: 70px;
            font-size: 11px;
        }
    }

    @media only screen and (max-width: 700px) {
        .duels-games .loading-placeholder {
            width: 100%;
            margin-right: 0!important;
        }

        .duels-games .loading-placeholder:nth-child(2) {
            margin-top: 20px;
        }

        .duels-games .games-all {
            margin-top: 20px;
        }
    }

    @media only screen and (max-width: 500px) {
        .duels-games {
            margin-top: 12px;
        }

        .duels-games .games-my {
            padding: 12px;
        }

        .duels-games .my-header {
            padding-bottom: 10px;
            margin-bottom: 12px;
        }

        .duels-games .header-title span {
            font-size: 14px;
        }

        .duels-games .content-empty {
            height: 60px;
            font-size: 10px;
        }
    }
</style>
